import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import routerTempHelpers from "@/utils/routerTempHelpers";
import { i18n } from "@/i18n/i18n-setup";

var CameraGuide =
/*#__PURE__*/
function (_Vue) {
  _inherits(CameraGuide, _Vue);

  function CameraGuide() {
    var _this;

    _classCallCheck(this, CameraGuide);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CameraGuide).apply(this, arguments));
    _this.guideType = ""; //hands face

    _this.resolveFn = void 0; //resovle

    _this.rejectFn = void 0; //reject

    _this.faceImg = {
      example: _this.$remoteImg("icons/camera_guide/face/correct_example_face@3x.png"),
      one: _this.$remoteImg("icons/camera_guide/face/no_human@3x.png"),
      two: _this.$remoteImg("icons/camera_guide/face/side_face@3x.png"),
      three: _this.$remoteImg("icons/camera_guide/face/too_dark@3x.png"),
      text_one: i18n.t("camera_guide.no_human"),
      text_two: i18n.t("camera_guide.side_face"),
      text_three: i18n.t("camera_guide.too_dark")
    };
    _this.handImg = {
      example: _this.$remoteImg("icons/camera_guide/hand/correct_example_hand@3x.png"),
      one: _this.$remoteImg("icons/camera_guide/hand/love_signal@3x.png"),
      two: _this.$remoteImg("icons/camera_guide/hand/ok_singal@3x.png"),
      three: _this.$remoteImg("icons/camera_guide/hand/thumb_signal@3x.png"),
      text_one: i18n.t("camera_guide.thumb_signal"),
      text_two: i18n.t("camera_guide.oK_signal"),
      text_three: i18n.t("camera_guide.love_signal")
    };
    return _this;
  }

  _createClass(CameraGuide, [{
    key: "removeRouterTempQuery",
    value: function removeRouterTempQuery() {
      routerTempHelpers.destroyTempQuery(this.$route.query);
    }
  }, {
    key: "init",
    value: function init() {
      if (routerTempHelpers.getQueryTemp(this.$route.query)) {
        this.resolveFn = routerTempHelpers.getQueryTemp(this.$route.query).resolve;
        this.rejectFn = routerTempHelpers.getQueryTemp(this.$route.query).reject;
        this.guideType = routerTempHelpers.getQueryTemp(this.$route.query).type;
      }
    }
  }, {
    key: "clickGot",
    value: function clickGot() {
      this.routerGoBack(-1);
      this.removeRouterTempQuery();
      this.resolveFn();
    }
  }, {
    key: "clickClose",
    value: function clickClose() {
      this.routerGoBack(-1);
      this.removeRouterTempQuery();
      this.rejectFn();
    }
  }, {
    key: "created",
    value: function created() {
      this.init();
    }
  }, {
    key: "imgMap",
    get: function get() {
      return this.guideType === "hand" ? this.handImg : this.faceImg;
    }
  }]);

  return CameraGuide;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], CameraGuide.prototype, "routerPush", void 0);

tslib_1.__decorate([Action(types.AGEING_FORECAST)], CameraGuide.prototype, "ageingForecast", void 0);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], CameraGuide.prototype, "routerGoBack", void 0);

CameraGuide = tslib_1.__decorate([Component({
  components: {
    Nav: Nav
  }
})], CameraGuide);
export default CameraGuide;